import React, { useEffect, useState } from 'react';
import styles from './DerivedViews.module.scss';
import Button from 'component/atom/forms/button/Button';
import DerivedViewsTable from './derived-views-table/DerivedViewsTable';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { derivedViews } from 'hooks/endpoints';
import Paginator from 'component/molecules/Table/TableComponents/TablePaginator/Paginator';
import Loader from 'component/atom/loader/Loader';

const DerivedViews = ({ agentData }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const { data, refetch, isLoading, isFetching } = useFetch(
    ['derivedViews'],
    derivedViews.fetchAllDerivedViews,
    {
      enable: true,
    },
    {
      agentId: agentData?.agentInDb?.id,
      pageSize: pageSize,
      pageNumber: pageNumber,
    }
  );

  useEffect(() => {
    refetch();
  }, [pageNumber]);

  const totalCount = data?.data?.totalCount || 0;
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className={styles['derived-view']}>
      <div className={styles['derived-view-header']}>
        <p className={styles['title']}>Derived Views</p>
        <Button
          label='Create Derived Views'
          onClick={() => {
            navigate(`/bot/create-derived-view/${agentData?.agentInDb?.id}`);
          }}
          type='plus'
        />
      </div>
      {isLoading || isFetching ? (
        <Loader isComponent />
      ) : (
        <DerivedViewsTable
          data={data?.data?.items}
          agentId={agentData?.agentInDb?.id}
        />
      )}
      <Paginator
        currentPage={pageNumber}
        totalPages={totalPages}
        onPageChange={(page) => setPageNumber(page)}
      />
    </div>
  );
};

export default DerivedViews;
